import $ from 'jquery';

import SiteHeader from "./components/site-header";
import HandheldMenu from "./components/handheld-menu";
import ProductsSlider from "./components/products-slider";
import CookiesConsent from "./components/cookies-consent";
import SlidesSlider from "./components/slides-section-slider";
import SummaryBlock from "./components/summary-block";
import DeviceManager from "./utils/device-manager";
import ScrollInView from "./components/scroll-in-view";

$(function () {
    const state = {
        gmapDependentComponentsInstanciated: false
    };
	const bootstrapApp = () => {
        const $html = $("html");

        // Touch device detection
        if (DeviceManager.isHandheld()) {
            $html.addClass("touch");

            if (DeviceManager.isIos()) {
                $html.addClass("ios");
            }
        } else {
            $html.addClass("no-touch");
        }

        // IE detection
        if (DeviceManager.isIe11()) {
            $html.addClass("ie11");
        } else if (DeviceManager.isEdge()) {
            $html.addClass("edge");
        }
    };

    const instanciateComponents = async () => {
        // General components
        const siteHeader = new SiteHeader($(".site-header"), 20);

        // Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
                window.siv = scrollInView;
			});
		}

        // Products slider
        const $productsSlider = $('.products-slider');
        if($productsSlider.length) {
            // Lazy load products slider script
            const { default: ProductsSlider } = await import('./components/products-slider.js');
            $productsSlider.each((index, el) => {
                // Instanciate products slider component
                let productsSliderInstance = new ProductsSlider($(el));
            });
        }

        // Text media slider
        const $textMediaSectionSlider = $('.text-image-section__slider');
        if($textMediaSectionSlider.length) {
            // Lazy load text media section slider script
            const { default: TextMediaSectionSlider } = await import('./components/text-media-section-slider.js');
            // Instanciate text media section slider components
            $textMediaSectionSlider.each(function (index, el) {
                let textMediaSectionSliderInstance = new TextMediaSectionSlider($(el));
            });
        }

        // Slides section slider
        const $sliderSlides = $(".slides-slider");
        if ($sliderSlides.length) {
            $sliderSlides.each(function (index, el) {
                let sliderSlides = new SlidesSlider($(el));
            });
        }

        // Store locator
        const $storeLocator = $('.store-locator');
        if($storeLocator.length) {
            // Lazy load store locator script
            const { default: StoreLocator } = await import('./components/store-locator/store-locator.js');
            $storeLocator.each((index, el) => {
                // Instanciate store locator component
                let storeLocatorInstance = new StoreLocator($(el), '/wp-content/themes/tribu/public/assets/json/france-geojson.json', index === 0);
            });
        }

        // Cookie consent
        if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
            // Tarteaucitron cookie settings
            let tarteaucitronLang = 'fr';

            const cookiesConsent = new CookiesConsent(tarteaucitronLang);
        }
    };

    bootstrapApp();
    instanciateComponents();
});
